
                                    import { renderToDOM } from './app.tsx';
                                    renderToDOM(document.getElementById('visualization-container-1'));
                                